import { createContext, useState, useEffect } from "react";
import {
    createShopifyCart,
    addCartLines,
    removeCartLines,
    fetchShopifyCart,
    normalizeCartLines,
} from '../lib/shopify';

export const CartContext = createContext();

const CART_ID_KEY = 'shopify_cart_id';

export const CartProvider = ({ children }) => {
    const [cartItem, setCartItem] = useState([]);
    const [cartTotal, setCartTotal] = useState(0);
    const [taxes, setTaxes] = useState(0);
    const [checkoutUrl, setCheckoutUrl] = useState('');

    const applyCart = (cart) => {
        if (!cart) return;
        const items = normalizeCartLines(cart);
        const total = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;
        const tax = Math.round(total * 0.13 * 100) / 100;
        setCartItem(items);
        setCartTotal(total);
        setTaxes(tax);
        setCheckoutUrl(cart.checkoutUrl || '');
    };

    const fetchCart = async () => {
        try {
            const cartId = localStorage.getItem(CART_ID_KEY);
            if (!cartId) {
                setCartItem([]);
                setCartTotal(0);
                setTaxes(0);
                return;
            }
            const cart = await fetchShopifyCart(cartId);
            if (!cart) {
                localStorage.removeItem(CART_ID_KEY);
                setCartItem([]);
                return;
            }
            applyCart(cart);
        } catch (error) {
            console.error('Error fetching cart', error);
            setCartItem([]);
            setCartTotal(0);
            setTaxes(0);
        }
    };

    const addToCart = async (variantId, quantity) => {
        const cartId = localStorage.getItem(CART_ID_KEY);
        let cart;
        if (cartId) {
            cart = await addCartLines(cartId, [{ merchandiseId: variantId, quantity }]);
        } else {
            cart = await createShopifyCart([{ merchandiseId: variantId, quantity }]);
            localStorage.setItem(CART_ID_KEY, cart.id);
        }
        applyCart(cart);
    };

    const removeFromCart = async (lineId) => {
        const cartId = localStorage.getItem(CART_ID_KEY);
        if (!cartId) return;
        const cart = await removeCartLines(cartId, [lineId]);
        applyCart(cart);
    };

    const clearCart = () => {
        setCartItem([]);
        setCartTotal(0);
        setTaxes(0);
        setCheckoutUrl('');
        localStorage.removeItem(CART_ID_KEY);
    };

    useEffect(() => {
        fetchCart();
    }, []);

    return (
        <CartContext.Provider value={{ cartItem, cartTotal, taxes, checkoutUrl, fetchCart, addToCart, removeFromCart, setCartItem, clearCart }}>
            {children}
        </CartContext.Provider>
    );
};
